/** basic.floorManage */
export default {
    floor_collectTips: "Добавить этот этаж в избранное?",
    floor_drawer: "Детали этажа",
    floor_news: "Информация об этаже",
    floor_dialogTItle: "Новый этаж",
    floor_createTIme: "Время создания:",
    floor_floor: "Этаж:",
    floor_floorPla: "Введите этаж",
    floor_messageSucc: "Этаж добавлен в избранное!",
    floor_messageLose: "Не удалось добавить этаж в избранное!",
    floor_floorNum: "этаж",

    add_floor: "Этаж",
    add_site: "Объект",
    add_reset: "Сброс",
    add_rulerNum: "Введите числовое значение",
    add_flooRules: "Этаж не может быть пустым",
    add_siteRules: "Объект не может быть пустым",

    img_addSucc: "Изображение загружено!",
    img_addLose: "Не удалось загрузить изображение!",
    floor_delete_tips: "Удалить этаж?",
}

